import { GA4Logger } from '@zep/analytics';
import {
  HyperdxLogger,
  registerLogger,
  SentryLogger,
  ZettaLogger,
} from '@zep/core-logger';
import { ZEPLogger } from '@zep/logger';

import { getInitialQuizTrackingState } from '../trackingContext';

import {
  ga4Dispatch,
  hyperdxLoggerConfig,
  Sentry,
  zettaClient,
} from './config';
import { GtmMarketingEventLogger } from './GtmMarketingEventLogger';

const zettaLogger = new ZettaLogger(zettaClient);
const ga4Logger = new GA4Logger({
  dispatch: ga4Dispatch,
});
const gtmMarketingEventLogger = new GtmMarketingEventLogger();

const hyperdxLogger = new HyperdxLogger(hyperdxLoggerConfig);
const sentryLogger = new SentryLogger(Sentry);

const appLogger = new ZEPLogger({
  loggers: [
    zettaLogger,
    ga4Logger,
    gtmMarketingEventLogger,
    hyperdxLogger,
    sentryLogger,
  ],
  initialState: {
    zep_service_name: 'zep-quiz',
    zep_deployment_env: process.env.NEXT_PUBLIC_STAGE,
    deploymentCommitId: process.env.NEXT_PUBLIC_COMMIT_SHA,
    ...getInitialQuizTrackingState(),
  },
});
registerLogger(appLogger);
